import React from "react";
import { useOverrides } from "@quarkly/components";
import { Text } from "@quarkly/widgets";
const defaultProps = {
	"margin": "8px 0px 16px 0px",
	"font": "normal 500 16px/175% --fontFamily-googleMontserrat",
	"sm-font": "normal 500 14px/160% \"Montserrat\", sans-serif",
	"color": "--grey",
	"padding": "20px 20px 20px 20px",
	"border-radius": "12px",
	"background": "--background",
	"children": `
<b>$SHOP_NAME$ - Ваш заказ (№ $ORDER_ID$)</b>

$ADD_DATE$ $ADD_TIME$ вы оформили заказ

$BODY$

💰 Сумма: $ORDER_TOTAL$

----------------------------------------------------------

Если вам удобнее оплатить переводом, то наши реквизиты:

💳 Карта МИР: <code>2204 1201 0770 4237</code>

<i>При оплате заказа укажите номер заказа (№ $ORDER_ID$) в комментариях</i>
	`
};
const overrides = {};

const ExampleCode = props => {
	const {
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Text {...rest} as="pre" font="monospace" whiteSpace="pre-wrap">
		{children}
	</Text>;
};

Object.assign(ExampleCode, { ...Text,
	defaultProps,
	overrides
});
export default ExampleCode;